<template>
<div id="bo-add-user">
  <div class="row">
    <div class="col-xs-12">
      <h1 class="text-primary">
        <small>{{ subtitle }}</small>
        <br>
        {{ title }}
      </h1>
      <hr>
    </div>
    <div :class="userCss">
      <p>
          Veuillez entrer les informations ci-dessous.
        </p>
        <div class="form-group"
             :class="{ 'has-error': nameError }">
          <input required
                 id="name"
                 tabindex="1"
                 class="form-control"
                 :disabled="waiting"
                 v-model.trim="userName"
                 type="text"
                 @blur="checkName()"
                 @keyup.enter="add"
                 placeholder="Nom"/>
        </div>
        <div class="form-group"
             :class="{ 'has-error': firstNameError }">
          <input required
                 id="firstName"
                 tabindex="1"
                 class="form-control"
                 :disabled="waiting"
                 v-model.trim="userFirstName"
                 type="text"
                 @blur="checkFirstName()"
                 @keyup.enter="add"
                 placeholder="Prénom"/>
        </div>
        <div class="form-group"
             :class="{ 'has-error': emailError }">
          <div class="input-group">
            <input required
                  id="userEmail"
                  tabindex="1"
                  class="form-control"
                  v-model.trim="userEmail"
                  :disabled="waiting"
                  type="email"
                  @keyup.enter="addMail"
                  placeholder="Adresse email"/>
            <span class="input-group-btn">
              <btn type="warning"
                   :disabled="this.userEmail === ''"
                   @click="addMail">
                Ajouter
              </btn>
            </span>
          </div>
        </div>
        <div class="form-group"
             v-if="this.userEmails.length !== 0">
          <div v-for="(u, k) in this.userEmails"
                :key="k">
            {{u}}
            <btn class="close" @click="removeMail(k)" aria-label="Close">
              <span aria-hidden="true">&times;
              </span>
            </btn>
          </div>
        </div>
        <collapse v-model="showError">
          <alert type="danger">
            <strong>{{ errorTitle }}</strong>
            <p>{{ error }}</p>
          </alert>
        </collapse>
        <btn id="add-button"
             type="success"
             tabindex="1"
             :disabled="waiting"
             block
             @click="add">Enregistrer</btn>
      </div>
  </div>
</div>
</template>

<script>
import tools from '@/sui/tools/main'

export default {
  name: 'bo-add-user',

  props: {
    title: String,
    subtitle: String,
    groups: Array,
    user: Object,
    userCss: String,
    routePrefix: String,
    storePrefix: String,
    action: String
  },

  data () {
    let result = {
      userName: '',
      userFirstName: '',
      userEmails: [],
      userId: '',
      userEmail: '',
      emailError: false,
      emailsError: false,
      nameError: false,
      firstNameError: false,
      errorTitle: '',
      error: '',
      waiting: false
    }
    if (this.user !== undefined) {
      result.userName = this.user.name
      result.userFirstName = this.user.firstName
      result.userEmails = this.user.email.slice()
      result.userId = this.user.id
    }

    return result
  },

  computed: {
    showError: function () {
      return this.error !== '' || this.errorTitle !== ''
    }
  },

  methods: {
    addMail () {
      if (this.checkEmail()) {
        this.userEmails.push(this.userEmail)
        this.userEmail = ''
      }
    },

    removeMail (i) {
      this.userEmails.splice(i, 1)
    },

    add: function () {
      this.errorTitle = ''
      this.error = ''

      if (!this.checkFormContent()) {
        return
      }

      this.waiting = true
      this.emailError = this.emailsError = this.firstNameError = this.nameError = false
      let request = {
        n: this.userName,
        f: this.userFirstName,
        em: this.userEmails,
        id: this.userId
      }
      if (this.action === 'add') {
        request.r = this.groups
        request.p = 'test'
      }
      let instance = this
      let nmMsg = (this.action === 'update') ? 'mis à jour' : 'inséré'
      let vbMsg = (this.action === 'update') ? 'de mettre à jour' : 'd\'insérer'

      this.$store.dispatch(`${this.storePrefix}/${this.action}`, request).then(
        (response) => {
          instance.waiting = false
          if (response.data.err != null) {
            instance.emailError = true
            instance.passwordError = true
            instance.errorTitle = 'Erreur interne.'
            instance.error = `Impossible ${vbMsg} l'utilisateur ${request.f} ${request.n} : 
${response.data.err}`
          } else {
            this.$notify({
              type: 'success',
              title: 'Succès !',
              content: `Utilisateur ${request.f} ${request.n} 
                      ${nmMsg} avec succès.`
            })
            this.$emit('end-edit-user', true)
          }
        }
      ).catch(function (e) {
        instance.waiting = false
        if (e.status === 500) {
          instance.errorTitle = 'Erreur interne.'
          instance.error = `Si cette erreur persiste, merci de contacter
un administrateur.`
        } else {
          instance.errorTitle = 'Serveur injoignable.'
          instance.error = `Merci de vérifier votre connexion internet.`
        }
      })
    },

    checkFormContent: function () {
      return this.checkEmails() > 0 && this.checkName() && this.checkFirstName()
    },

    checkName: function () {
      this.nameError = (this.userName === '')
      this.error = (this.nameError) ? 'Aucun nom saisi.' : ''

      return !this.nameError
    },

    checkFirstName: function () {
      this.firstNameError = (this.userFirstName === '')
      this.error = (this.firstNameError) ? 'Aucun prénom saisi.' : ''

      return !this.firstNameError
    },

    checkEmail: function () {
      this.emailError = !tools.isEmailValid(this.userEmail)
      this.error = (this.emailError)
        ? 'L\'adresse email saisie est invalide.' : ''

      return !this.emailError
    },

    checkEmails: function () {
      this.emailsError = this.userEmails.length === 0
      this.error = (this.emailsError)
        ? 'Aucune adresse email saisie.' : ''

      return !this.emailsError
    }
  }
}
</script>

<style scoped lang="less">
.label {
    display: inline-block;
}
.panel-body {
    padding: 0.3rem;
}
</style>
